import qs from 'qs';
import { cloneDeep } from 'lodash';
import { store } from './store';
import moment from 'moment';
import * as Yup from 'yup';
const tableHelper = {
  selectAll: (arr, ids) => [...arr, ...ids.filter((id) => !arr.includes(id))],
  deselectAll: (arr, ids) => arr.filter((ar) => !ids.includes(ar)),
};
export default {
  getSetting,
  updateExpiredTime,
  isRequireConfirmation,
  checkPermission,
  getUserDepartment,
  centralizeError,
  sortDateFunc,
  isMobile,
  getStatusIconName,
  parseQueryString,
  compileQueryString,
  pwdValidationSchema,
  tableHelper,
  getRoleTooltip,
  clearSiteCache,
};

function getSetting(settingName, deptSettings) {
  let settings;
  if (deptSettings) {
    settings = deptSettings;
  } else {
    //get current user dept setting
    settings = JSON.parse(localStorage.getItem('departmentSettings')) || [];
  }
  const setting = settings.filter((s) => s.parameter === settingName);
  if (setting.length) {
    return setting[0];
  } else {
    throw new Error('Department setting not existed');
  }
}

function updateExpiredTime() {
  try {
    const _t = getSetting('SessionTimeoutMinutes').value;
    return moment().add(_t, 'minutes').toISOString();
  } catch (error) {
    return moment().add('5', 'minutes').toISOString();
  }
}

function isRequireConfirmation() {
  return getSetting('RequireConfirmation').value.toLowerCase() === 'true';
}

function checkPermission(permission) {
  const { currentUserPermissions } = store.getState().permissions;
  return currentUserPermissions.includes(permission);
}

function getUserDepartment() {
  const { departmentId, departmentName } = JSON.parse(
    localStorage.getItem('userProfile'),
  );
  return { deptId: departmentId, deptName: departmentName };
}

function centralizeError(errors) {
  let result = '';
  for (let index = 0; index < errors.length; index++) {
    if (errors[index]) {
      result += `\n ${errors[index]}`;
    } else {
      result += errors[index];
    }
    result = result.trim();
  }
  return result;
}

function sortDateFunc(a, b, order, dataField, rowA, rowB) {
  if (order === 'asc') {
    return Date.parse(a) - Date.parse(b);
  } else if (order === 'desc') {
    return Date.parse(b) - Date.parse(a);
  }
}

function isMobile() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

function getStatusIconName(iconName) {
  switch (iconName) {
    case 'Disabled.png':
      return 'Disabled';
    case 'Error.png':
      return 'Error';
    case 'ErrorNoLog.png':
      return 'Error, Logging Disabled';
    case 'ErrorOverride.png':
      return 'Error, Override';
    case 'HiAlarm.png':
      return 'High Alarm';
    case 'HiAlarmNoLog.png':
      return 'High Alarm, Logging Disabled';
    case 'HiAlarmOverride.png':
      return 'High Alarm, Override';
    case 'HiWarn.png':
      return 'High Warning';
    case 'HiWarnNoLog.png':
      return 'High Warning, Logging Disabled';
    case 'HiWarnOverride.png':
      return 'High Warning, Override';
    case 'LoAlarm.png':
      return 'Low Alarm';
    case 'LoAlarmNoLog.png':
      return 'Low Alarm, Logging Disabled';
    case 'LoAlarmOverride.png':
      return 'Low Alarm, Override';
    case 'LoWarn.png':
      return 'Low Warning';
    case 'LoWarnNoLog.png':
      return 'Low Warning, Logging Disabled';
    case 'LoWarnOverride.png':
      return 'Low Warning, Override';

    case 'OKNoLog.png':
      return 'OK, Logging Disabled';
    case 'OKOverride.png':
      return 'OK, Override';
    case 'NoAlarm.png':
      return 'Alarm Disabled';
    default:
      return 'OK';
  }
}

function parseQueryString(search) {
  return qs.parse(search, { ignoreQueryPrefix: true });
}
function compileQueryString(obj) {
  let _obj = cloneDeep(obj);
  for (const key in _obj) {
    if (!_obj[key]) {
      _obj[key] = [];
    }
  }
  return qs.stringify(_obj, { skipNulls: true, addQueryPrefix: true });
}

function countUniChar(str) {
  // A map (in JavaScript, an object) for the character=>count mappings
  var counts = {};

  // Misc vars
  var ch, index, len, count;

  // Loop through the string...
  for (index = 0, len = str.length; index < len; ++index) {
    // Get this character
    ch = str.charAt(index); // Not all engines support [] on strings

    // Get the count for it, if we have one; we'll get `undefined` if we
    // don't know this character yet
    count = counts[ch];

    // If we have one, store that count plus one; if not, store one
    // We can rely on `count` being falsey if we haven't seen it before,
    // because we never store falsey numbers in the `counts` object.
    counts[ch] = count ? count + 1 : 1;
  }
  return Object.keys(counts).filter((key) => counts[key] === 1).length;
}

function pwdValidationSchema({ containConfirm, pwdStrength, settings }) {
  const confirmPassword = Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Password confirm is required');
  const comparator = /true|True/g;
  function isTrue(deptSetting) {
    const result = deptSetting.value.match(comparator);
    if (result !== null) return true;
    return false;
  }
  const digitReg = new RegExp(/\d+/g);
  const lowercaseReg = new RegExp(/[a-z]/g);
  const uppercaseReg = new RegExp(/[A-Z]/g);
  const specialReg = new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/);
  const isDigit = isTrue(getSetting('PasswordRequireDigit', settings));
  const pwdLength = getSetting('PasswordRequiredLength', settings).value;
  const pwdComplexity = getSetting('PasswordComplexity', settings);
  const numUniqueChars = getSetting(
    'PasswordRequiredUniqueChars',
    settings,
  ).value;
  const isLower = isTrue(getSetting('PasswordRequireLowercase', settings));
  const isNonAlphaNum = isTrue(
    getSetting('PasswordRequireNonAlphanumeric', settings),
  );
  const isUpper = isTrue(getSetting('PasswordRequireUppercase', settings));
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required('Password is required')
      .test('is-digit', 'Password need at least a digit', (value = '') => {
        if (isDigit) {
          return value.match(digitReg);
        } else return value;
      })
      .test(
        'length',
        `Password length must be more than ${pwdLength}`,
        (value = '') => {
          return value.length >= parseInt(pwdLength);
        },
      )
      .test(
        'unique character',
        `Password must contain at least ${numUniqueChars} unique character`,
        (value = '') => {
          const _value = countUniChar(value);
          return _value >= parseInt(numUniqueChars);
        },
      )
      .test('lower case', `Password must contain a lowercase`, (value = '') => {
        if (isLower) {
          return value.match(lowercaseReg);
        } else return value;
      })
      .test('upper case', `Password must contain a uppercase`, (value = '') => {
        if (isUpper) {
          return value.match(uppercaseReg);
        } else return value;
      })
      .test(
        'special character',
        `Password must contain a special character`,
        (value = '') => {
          if (isNonAlphaNum) {
            return value.match(specialReg);
          } else return value;
        },
      ),
    // .test('password strength', `Password is too weak`, (value = '') => {
    //   return pwdStrength >= pwdComplexity;
    // }),
    confirmPassword: containConfirm ? confirmPassword : null,
  });
  return validationSchema;
}

function getRoleTooltip(roleName) {
  switch (roleName) {
    case 'AbpIdentity.Roles':
      return 'Access the Add/Edit Roles page';
    case 'API.Department':
      return 'Access the Add/Edit Departments page';
    case 'API.GroupSetting':
      return 'Access the Add/Edit Groups page';
    case 'API.SensorTypes':
      return 'Access the Sensor Type Settings page';
    case 'API.Sensors.Disable':
      return 'Disable monitoring points from the Dashboard';
    case 'API.Sensors.Enable':
      return 'Enable monitoring points from the Dashboard';
    case 'API.Sensors.ModifyAtRestState':
      return "Modify a group's In Operation/At Rest state from the Dashboard";
    case 'API.Units':
      return 'Access the Add/Edit Units page';
    case 'API.Notes':
      return 'Add Notes to monitoring points on the Dashboard';
    case 'API.RemoteStations':
      return 'Access the Manage Remote Devices page';
    case 'API.AlarmIndicators':
      return 'Access the Alarm Indicator Settings page (used for stacklights, horns, etc.)';
    case 'API.AckPhrases':
      return 'Access the Add/Edit Phrases page';
    case 'API.SensorExchanges':
      return 'Access the Sensor Exchanges page';
    case 'API.Maps':
      return 'Access the Maps Management page';
    case 'API.ScheduledReports':
      return 'Access the Add/Edit Scheduled Reports page';
    case 'API.Reports.StatisticsDetail':
      return 'Access the Statistics Detail report';
    case 'API.Reports.Sensor':
      return 'Access the Sensor report';
    case 'API.Reports.AlarmHistory':
      return 'Access the Alarm History report';
    case 'API.Reports.GroupStatus':
      return 'Access the Group Status report';
    case 'API.Reports.GroupStatusStatistics':
      return 'Access the Group Status Statistics report';
    case 'API.Reports.LimitsChanged':
      return 'Access the Limits Changed report';
    case 'API.Reports.MeasurementLog':
      return 'Access the Sensor Measurement Log report';
    case 'API.Reports.UserNotes':
      return 'Access the User Notes report';
    case 'API.Reports.BatchReports':
      return 'Access the Batch Reports page';
    case 'API.Reports.MKTMonitors':
      return 'Access the MKT Monitors page';
    case 'API.Reports.Audits':
      return 'Access the Audit report';
    case 'API.Users.ResetPassword':
      return "Reset a user's password (any user assigned to this user's department)";
    case 'API.Users.ExpirePassword':
      return "Expire a user's password (any user assigned to this user's department)";
    case 'API.Users.LockUser':
      return "Lock a user (any user assigned to this user's department)";
    case 'API.Users.UnlockUser':
      return "Unlock a user (any user assigned to this user's department)";
    case 'API.Users.ActiveUser':
      return "Set a user to Active (any user assigned to this user's department)";
    case 'API.Users.InactiveUser':
      return "Set a user to Inactive (any user assigned to this user's department)";
    case 'API.AckAlarms':
      return 'Acknowledge rows in the Alarm List on the Dashboard';
    case 'API.MobileConfigurations':
      return 'Access the Mobile Configurations page';
    case 'API.SensorCalibrations':
      return 'Access the Import Calibration Swap Data page';
    case 'API.Statistics':
      return 'Access the Statistics page';
    case 'API.Widgets':
      return 'Ability to add custom widgets to the Custom Dashboard Designer page';
    default:
      return '';
  }
}

async function clearSiteCache() {
  var theCookies = document.cookie.split(';');
  for (var i = 1; i <= theCookies.length; i++) {
    var acookie = theCookies[i - 1];
    var cookieArr = acookie.split('=');

    document.cookie =
      cookieArr[0] + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  // Get cache storage and clear cache storage
  window.caches.keys().then(function (names) {
    for (let name of names) window.caches.delete(name);
  });

  // Get indexed db and delete indexed db
  const dbs = await window.indexedDB.databases();
  dbs.forEach((db) => {
    window.indexedDB.deleteDatabase(db.name);
  });

  // clear localStorage
  window.localStorage.clear();

  // clear sessionStorage
  window.sessionStorage.clear();
}
